<template>
  <el-dialog :title="istitle" :visible.sync="domVisible" :custom-class="isdialogClass" :lock-scroll="false" :before-close="handleClose" v-loading="addloading">
    <div v-if="!isNew">
      <el-radio-group class="address_box" v-model="radio">
        <div class="address_list" v-for="(item,index) in address" :key="index">
          <el-radio class="address_checkbox" :label="item">
            <div class="on_Default" v-if="item.IsDefault">{{$t('base.default')}}</div>
            <div><span>{{item.UserName}}</span> ({{item.Country}})</div>
            <div class="line_txt2" :title="((item.StreetAddress !=null ? item.StreetAddress+',':'')+(item.StreetAddress2 !=null&&item.StreetAddress2!='' ? item.StreetAddress2+',':'')+(item.City !=null ? item.City+',':'')+(item.StateCode !=null ? item.StateCode+',':'')+item.ZipCode)">
              <span>{{item.StreetAddress !=null ? item.StreetAddress+', ':''}}</span>
              <span v-if="item.StreetAddress2 !=null&&item.StreetAddress2!=''">{{item.StreetAddress2 !=null&&item.StreetAddress2!='' ? item.StreetAddress2+', ':''}}</span>
              <span>{{item.City !=null ? item.City+', ':''}}</span>
              <span>{{item.StateCode !=null ? item.StateCode+', ':''}}</span>
              <span>{{item.ZipCode}}</span>
            </div>
          </el-radio>
        </div>
      </el-radio-group>
      <div class="addNEW" @click="addNEW">+{{ $t('base.addNewAddress') }}</div>
      <div slot="footer" class="dialog_footer">
        <el-button @click="handleClose()">{{$t('base.cancel')}}</el-button>
        <el-button type="primary" @click="addSave">{{$t('base.save')}}</el-button>
      </div>
    </div>
    <div v-if="isNew">
      <div class="dialogData" v-loading="disabled">
        <el-form :model="passForm" :rules="passRules" ref="passForm" :hide-required-asterisk='true' class="set_form">
          <div class="address_box country">
            <el-form-item :label="$t('colon.country')" class="info_box" prop="Country">
              <el-input class="info_ipt" v-model="passForm.Country" :disabled="true"></el-input>
              <!-- <el-select v-model="passForm.Country" class="info_ipt">
                <el-option label="US" value="US"></el-option>
              </el-select> -->
            </el-form-item>
            <!-- <div class="currently">Currently, we only accept U.S. address.</div> -->
          </div>
          <div class="address_box">
            <el-form-item :label="$t('colon.name')" class="info_box" prop="UserName">
              <el-input class="info_ipt" v-model="passForm.UserName" max="30"></el-input>
            </el-form-item>
          </div>
          <div class="address_box">
            <el-form-item :label="$t('colon.street1')" class="info_box" prop="StreetAddress">
              <el-input class="info_ipt" v-model="passForm.StreetAddress" max="100"></el-input>
            </el-form-item>
            <el-form-item :label="$t('colon.street2')" class="info_box" prop="StreetAddress2">
              <el-input class="info_ipt" v-model="passForm.StreetAddress2" max="100"></el-input>
            </el-form-item>
          </div>
          <div class="address_box">
            <el-form-item :label="$t('colon.city')" class="info_box" prop="City">
              <el-input class="info_ipt" v-model="passForm.City" max="30"></el-input>
            </el-form-item>
            <el-form-item :label="$t('colon.state')" class="info_box" prop="StateCode">
              <el-select v-model="passForm.StateCode" filterable class="info_ipt" @change='getState' :placeholder="$t('base.selectState')">
                <el-option :label="item.EName" :value="item.Code" v-for="(item,index) in getAreas" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="address_box">
            <el-form-item :label="$t('colon.zipCode')" class="info_box" prop="ZipCode">
              <el-input class="info_ipt" v-model="passForm.ZipCode" max="30"></el-input>
            </el-form-item>
            <el-form-item :label="$t('colon.phone')" class="info_box" prop="Phone">
              <el-input class="info_ipt" v-model="passForm.Phone" max="30"></el-input>
            </el-form-item>
          </div>
          <div class="set_btn" style="text-align: right;">
            <el-button @click="resetForm('passForm')">{{$t('base.cancel')}}</el-button>
            <el-button type="primary" :disabled="disabled" @click="submitForm('passForm')">{{$t('base.save')}}</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { addressList, isEmoji } from "@/api/public";
import qs from 'qs'
export default {
  name: '',
  data() {
    var isChinese = (rule, value, callback) => {
      let msg = this.$t('rules.enterAddress')
      if (value == '' && rule.field == 'StreetAddress') {
        callback(new Error(msg));
      }
      let Country=''
      if(this.userInfo){
        Country=this.userInfo.MemberSource
      }
      let isChinese = 'HK,TWN,MO,CN'
      if (isChinese.indexOf(this.passForm.Country) > -1) {
        let text = this.passForm.StreetAddress + this.passForm.StreetAddress2
        let reg = /[\u4E00-\u9FA5]/g;
        let ChineseLength = (text.match(reg) || []).length
        if (ChineseLength < 4) {
          msg = this.$t('rules.isChinese')
          callback(new Error(msg));
        }
        setTimeout(() => {
          if (rule.field == 'StreetAddress') {
            if(ChineseLength < 4){
              this.$refs['passForm'].validateField('StreetAddress2')
            }
          }
          if (rule.field == 'StreetAddress2') {
            this.$refs['passForm'].validateField('StreetAddress')
          }
        })
      }
      callback();
    }
    return {
      isNew: false,
      address: '',
      radio: null,
      addloading: false,
      isdialogClass: '',
      istitle: '',
      getAreas: '',
      disabled: false,
      orderadd: '',
      orderaddString: '',
      passForm: {
        Country: "",
        UserName: '',
        StreetAddress: '',
        StreetAddress2: '',
        City: '',
        StateCode: '',
        State: '',
        ZipCode: '',
        Phone: '',
      },
      passRules: {
        Country: [
          { required: true, message: this.$t('rules.enterCountry'), trigger: 'blur' }
        ],
        UserName: [
          { required: true, message: this.$t('rules.enterName'), trigger: 'blur' }
        ],
        StreetAddress: [
          { validator: isChinese, trigger: 'blur' },
          //{ required: true, message: this.$t('rules.enterAddress'), trigger: 'blur' }
        ],
        StreetAddress2: [
          { validator: isChinese, trigger: 'blur' },
          //{ required: true, message: 'Please enter your Address2', trigger: 'blur' }
        ],
        City: [
          { required: true, message: this.$t('rules.enterCity'), trigger: 'blur' }
        ],
        StateCode: [
          { required: true, message: this.$t('rules.selectState'), trigger: 'change' }
        ],
        ZipCode: [
          { required: true, message: this.$t('rules.enterZipCode'), trigger: 'blur' }
        ],
        Phone: [
          { required: true, message: this.$t('rules.enterPhone'), trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    dialogClass: '',
    title: "",
    domVisible: Boolean,
    list: {},
    userInfo: {},
    type: String
  },
  watch: {},
  filters: {},
  created() {
    this.isdialogClass = this.dialogClass;
    this.istitle = this.title;
    if (this.type == 'store') {
      // 官方商城
      this.GetOrderStoreDetail()
    } else {
      // 普通订单
      this.GetOrderDetail()
    }
  },
  methods: {
    handleClose() {
      this.$emit('closeDialog', 'address', false)
    },
    addNEW() {
      this.isdialogClass = 'addNEW'
      this.istitle = this.$t('base.addNewAddress')
      this.isNew = true;
      this.passForm.Country = this.userInfo.MemberSource
      this.getAreasList();
      // this.isdialogClass=this.dialogClass
      // this.istitle=this.title
    },

    //select 州
    getState(val) {
      let that = this
      that.getAreas.map(res => {
        if (res.Code == val) {
          that.passForm.State = res.EName
        }
      })
    },
    //保存地址
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let url = this.$interface.SaveAddresses
          let data = {
            "memberId": that.userInfo.Id,
            "country": that.passForm.Country,
            "userName": that.passForm.UserName,
            "streetAddress": that.passForm.StreetAddress,
            "streetAddress2": that.passForm.StreetAddress2,
            "city": that.passForm.City,
            "stateCode": that.passForm.StateCode,
            "state": that.passForm.State,
            "zipCode": that.passForm.ZipCode,
            "phone": that.passForm.Phone,
            // 'isDefault':that.checkAdd.IsDefault
          }
          that.disabled = true;
          that.$post(url, data).then(res => {
            if (res.Result != 0) {
              that.getAddressList(that.orderaddString, that.orderadd)
              that.isNew = false;
              that.isdialogClass = 'dialogBox'
              that.istitle = that.title;
              that.disabled = false;
              that.$refs[formName].resetFields();

            } else {
              that.disabled = false;
              that.$refs[formName].resetFields();
              this.$message({
                type: 'error',
                message: res.msg
              });
            }
          })
          //console.log(url, data)
        }
      });
      //this.dialogVisible = false
    },
    //取消保存地址
    resetForm(formName) {
      this.$refs[formName].resetFields();

      this.isdialogClass = 'dialogBox'
      this.isNew = false;
    },
    //获取地区列表
    getAreasList(val) {
      let that = this;
      let data = { code: that.userInfo.MemberSource }
      this.$get(this.$interface.GetAreas, data).then(res => {
        if (res.Result != 0) {
          that.getAreas = res.Data;

        }
      })
    },
    // 获取地址列表
    getAddressList(val, obj) {
      let data = val
      let that = this
      that.addloading = true;
      this.address = [];
      addressList().then(res => {
        if (res.Result != 0) {
          this.address = res.Data
          this.address.map((val, i) => {
            let old = val.UserName + val.StreetAddress + val.StreetAddress2 + val.City + val.State + val.Phone + val.ZipCode
            //console.log(old === data, old, '|', data)
            if (old === data) {
              this.radio = obj
              that.addloading = false;
              if (val.IsDefault) {
                obj.IsDefault = true
              }
              //console.log("121212", this.address)
              this.address.splice(i, 1)
              this.address.unshift(obj)
            }
          })
        }
        that.addloading = false;
      })
    },
    // 获取订单详情用来改地址
    GetOrderDetail() {
      let that = this
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, orderId: that.list.ID }
      that.addloading = true
      this.$get(this.$interface.OrdersDetail, data).then(res => {
        if (res.result != 0) {
          let result = res.data
          let add = ''
          let address = result.Address
          //console.log(result, 'address1')

          if (address.indexOf('()') > 0) {
            // var a=add1.indexOf('()')
            // console.log(add1,a,'add2',add1.substring(0,a))
            //var reg=new RegExp()
            address = address.replace(/\(\)/g, "")
            address = [address]
            //console.log(add1,a,'add1')
          } else {
            address = address.replace(")", "")
            address = address.replace("(", "|")
            address = address.split("|")
          }
          //console.log(address, 'address')
          let item = {
            "Id": null,
            "Country": "US",
            "UserName": result.Consignee,
            "City": result.City,
            "StreetAddress": address[0],
            "StreetAddress2": address[1] ? address[1] : "",
            "StateCode": result.Provice,
            "ZipCode": result.ZipCode,
            "Phone": result.Mobile,
          }
          add = result.Consignee + address[0] + (address[1] ? address[1] : "") + result.City + result.Provice + result.Mobile + result.ZipCode
          that.orderaddString = add
          that.orderadd = item
          this.getAddressList(add, item)
        }
      })
    },
    //获取官方商城订单详情用来改地址
    GetOrderStoreDetail() {
      let that = this
      //console.log(that.list, 'that.list')
      let data = { memberid: that.userInfo.MappingUserId, orderId: that.list.Id }
      this.$get(this.$interface.GetStoreOrderById, data).then(res => {
        if (res.Result != 0) {
          let data = res.Data
          let add = data.AddressMsg.AddressDetail
          if (add) {
            if (add.indexOf('()') > 0) {
              // var a=add1.indexOf('()')
              // console.log(add1,a,'add2',add1.substring(0,a))
              //var reg=new RegExp()
              add = add.replace(/\(\)/g, "")
              add = [add]
              //console.log(add, 'add1')
            } else {
              if (add.indexOf(')') != -1) {
                add = add.replace(")", "")
                add = add.replace("(", "|")
              }
              add = add.split("|")
            }
          }
          // 重组地址信息
          let result = {
            UserName: data.AddressMsg.Consignee,
            Country: data.AreaCode,
            StreetAddress: add[0] ? add[0] : add,
            StreetAddress2: add[1] ? add[1] : '',
            ZipCode: data.AddressMsg.PostalCode,
            City: data.AddressMsg.CityName,
            State: data.AddressMsg.ProvinceName,
            Phone: data.AddressMsg.Telephone,
            StateCode: '',
          }
          add = data.AddressMsg.Consignee + add[0] + (add[1] ? add[1] : "") + data.AddressMsg.CityName + data.AddressMsg.ProvinceName + data.AddressMsg.Telephone + data.AddressMsg.PostalCode
          that.orderaddString = add
          that.orderadd = result
          this.getAddressList(add, result)
        }
      })
    },
    // 更新订单信息
    addSave() {
      let that = this
      if (that.type == 'store') {
        that.updataStoreOrder()
      } else {
        that.updataOrder()
      }
    },
    //更新普通订单
    updataOrder() {
      let that = this
      let data = ""
      let url = ""
      if (that.radio != '') {
        if (that.radio.Id != null) {
          if (that.list.OrderType != 1) {
            data = { memberid: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, addressId: that.radio.Id, orderId: that.list.ID }
            url = this.$interface.UpdateOrder
          } else {
            data = { MemberId: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, AddressID: that.radio.Id, OrderId: that.list.ID, IsGuarantee: 3, GBC: 0, CommodityIds: '', QuantitySold: '', couponMemberID: '' }
            url = this.$interface.OfficialAddOrder
          }
          this.addloading = true
          this.$post(url, qs.stringify(data)).then(res => {
            if (res.result != 0) {
              that.handleClose()
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              });
              this.addloading = false
            }
          })
        } else {
          that.handleClose()
        }
      } else {
        this.handleClose()
      }
    },
    //更新官方订单
    updataStoreOrder() {
      let that = this
      if (that.radio != '') {
        if (that.radio.Id != null) {
          let obj = that.radio
          let addressMsg = {
            addressId: obj.Id,
            consignee: obj.UserName,
            telephone: obj.Phone,
            postalCode: obj.ZipCode,
            provinceName: obj.State,
            cityName: obj.City,
            addressDetail: obj.StreetAddress + ("(" + obj.StreetAddress2 + ")")
          }
          this.addloading = true
          let data = { memberId: that.userInfo.MappingUserId, orderId: that.list.Id, isSelfPickup: false, addressMsg }
          this.$post(that.$interface.UpdateStoreAddress, data).then(res => {
            if (res.Result != 0) {
              that.handleClose()
            } else {
              this.$message({
                type: 'error',
                message: res.Msg
              });
              this.addloading = false
            }
          })
        } else {
          that.handleClose()
        }
      } else {
        that.handleClose()
      }

    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/historylist.css";

.address_checkbox .line_txt2 span {
  font-weight: 400;
}

.dialogData .address_box {
  width: 100%;
  display: flex;
}

.info_box {
  width: 240px;
}
.info_box+.info_box{
  margin-left: 24px;
}

.addNEW {
  color: #5f6dae;
  line-height: 16px;
  margin-top: 10px;
  cursor: pointer;
}

.address_list {
  position: relative;
}

.on_Default {
  top: -12px;
  right: -12px;
  border-top-right-radius: 4px;
}

.dialogData .address_box {
  overflow: hidden;
}

.address_box.country {
  margin-bottom: 10px;
  position: relative;
}

.address_box.country .currently {
  position: absolute;
  top: 65px;
  left: 24px;
  font-size: 12px;
  color: #999;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/changeaddress.vue